import React, { useState, useEffect } from 'react';
import { Box, Grid, InputLabel, TextField } from '@mui/material';
import { AppColors } from '../../../../Utils/helper/AppColors';
import StepperHeading from '../StepperHeading';
import { useSelector } from 'react-redux';
import { FloatingLabelSelect } from '../../../../Components/FloatingLabelSelect';
import CultService from '../../../../Services/CultService';
import { Select } from 'antd';

const MAX_CHAR = 275;
const MAX_NAME = 120;

export default function BasicDetails({ details, setDetails }) {
	const [campaignType, setCampaignType] = useState([]);
	const company = useSelector((state) => state?.app?.company);
	// console.log('company', company);
	// console.log('details', details);

	const handleInputChange = (e) => {
		let newVal = e.target.value;
		if (e.target.name === 'description') {
			if (newVal.length > MAX_CHAR) {
				newVal = newVal.slice(0, MAX_CHAR);
			}
		}
		if (e.target.name === 'name') {
			if (newVal.length > MAX_NAME) {
				newVal = newVal.slice(0, MAX_NAME);
			}
		}

		setDetails({
			...details,
			basicDetails: {
				...details?.basicDetails,
				[e.target.name]: newVal,
			},
		});
	};

	const getcampaignType = async () => {
		let res = await CultService.getFilterValues({ params: { companyId: company._id } });
		// console.log('res', res);
		setCampaignType(res?.data?.campaignTypes || []);
	};

	useEffect(() => {
		if (company) getcampaignType();
	}, [company]);

	const handleSelectCampaignType = (newValue) => {
		const selectedValue = newValue.slice(-1);
		setDetails({ ...details, basicDetails: { ...details?.basicDetails, campaignType: selectedValue[0] } });
		if (selectedValue.length && !campaignType.includes(selectedValue[0])) {
			setCampaignType([...campaignType, selectedValue[0]]);
		}
	};

	return (
		<Box p={3}>
			{/* <StepperHeading title="Basic Details" subTitle="Fill in the basic campaign details" /> */}
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TextField
						// required
						name="name"
						id="outlined-required"
						value={details?.basicDetails?.name}
						onChange={handleInputChange}
						size="small"
						fullWidth
						label="Campaign Name"
						InputLabelProps={
							{
								// shrink: true,
							}
						}
						inputProps={{ maxLength: MAX_NAME }}
						sx={(theme) => ({
							'& .MuiOutlinedInput-root': {
								'& fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&:hover fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&.Mui-focused fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
							},
						})}
					/>{' '}
				</Grid>

				<Grid item xs={4}>
					<FloatingLabelSelect
						label="Campaign Type"
						mode="tags"
						placeHolderfontSize={12}
						value={details?.basicDetails?.campaignType} 
						onChange={handleSelectCampaignType}
						allowClear
					>
						{campaignType?.map((option) => (
							<Select.Option key={option} value={option}>
								{option}
							</Select.Option>
						))}
					</FloatingLabelSelect>
				</Grid>

				<Grid item xs={12}>
					<TextField
						name="description"
						id="outlined-required"
						label="Description"
						InputLabelProps={
							{
								// shrink: true,
							}
						}
						placeholder="Write a short introduction."
						inputProps={{ maxLength: MAX_CHAR }}
						value={details?.basicDetails?.description}
						onChange={handleInputChange}
						helperText={`${MAX_CHAR - (details?.basicDetails?.description?.length || 0)} characters left`}
						fullWidth
						multiline
						rows="8"
						size="small"
						sx={(theme) => ({
							'& .MuiOutlinedInput-root': {
								'& fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&:hover fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
								'&.Mui-focused fieldset': {
									borderColor: theme.palette.primary.lightest_shade,
									borderRadius: '10px',
								},
							},
						})}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}
